<template>
  <ul
    v-if="loading"
    class="tree overflow-hidden"
    style="padding-left: 1.5rem; cursor: progress; max-width: 20rem"
  >
    <li v-for="k1 in placeholderNum(8, 12)" :key="k1" class="placeholder-wave w-100 pt-1">
      <span :class="`placeholder col-${placeholderNum(2, 6)}`"></span>
      <ul class="tree w-100" style="padding-left: 1.5rem">
        <li v-for="k3 in placeholderNum(1, 5)" :key="k3" class="placeholder-wave w-100 pt-1">
          <span :class="`placeholder col-${placeholderNum(5, 12)}`"></span>
        </li>
      </ul>
    </li>
  </ul>
  <slot v-else-if="tree.length === 0 && depth === 0" name="error">
    <div
      v-bind="$attrs"
      class="tree d-flex flex-column align-items-center justify-content-center h-100"
      style="max-width: 20rem"
    >
      <div class="d-flex align-items-center mb-1">
        <Icon icon="material-symbols:info-outline" class="fs-4 me-1" />
        <p class="m-0">Tree is empty</p>
      </div>
    </div>
  </slot>
  <ul v-else class="tree custom-scrollbar" :style="{overflow: depth ? 'hidden' : 'auto'}">
    <TreeViewNode
      v-for="(t, index) in tree"
      :key="index"
      :node="t"
      :depth="depth || 0"
      :expand-all="expandAll"
      :active="active"
      @update:active="(n: TreeViewNode) => $emit('update:active', n)"
    >
      <template #nodeIcon="slotProps">
        <slot name="nodeIcon" v-bind="slotProps" />
      </template>
    </TreeViewNode>
  </ul>
</template>
<script setup lang="ts">
import type {TreeViewNode} from '@/components/shared/custom/TreeView/TreeViewNode.vue';
const {placeholderNum} = usePlaceholderNum();
const {
  tree,
  depth = 0,
  expandAll = false,
  loading,
  active = undefined,
} = defineProps<{
  tree: readonly TreeViewNode[];
  depth?: number;
  expandAll?: boolean;
  loading?: boolean;
  active?: TreeViewNode;
}>();
defineEmits<{'update:active': [node: TreeViewNode]}>();
defineSlots(); // https://github.com/vuejs/core/issues/5312
</script>
<style lang="scss" scoped>
.tree {
  inline-size: 20rem;
}

.tree,
.tree-node-children {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
  list-style: none;
}
</style>
